module.exports = __webpack_public_path__ + "img/product-uphold.8064248.webp";